<template>
  <div>
    <v-container grid-list-xl fluid v-if="news.length > 0">
      <v-layout row wrap>
        <v-toolbar flat color="transparent" height="50">
          <h3>Tất cả bản tin</h3>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-flex lg12>
          <notification-table :datasource="news"/>
        </v-flex>
      </v-layout>
    </v-container>
    <div v-else>
      <blank
        :src="`/static/icons/blank/news.png`"
        :firstLine="`Chưa có dữ liệu`"
        :secondLine="`Các thông báo, bản tin từ nhà cung cấp Vietmap Motrak sẽ được hiển thị tại đây. Nếu cần hỗ trợ quý khách có thể liên hệ qua số Hotline 1900 633 378 để được trợ giúp`"
        :width="360"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NotificationTable from './components/List';
import Blank from '@/components/Blank';

export default {
  components: {
    NotificationTable,
    Blank
  },
  computed: {
    ...mapGetters(['news'])
  },
  created () {
    this.getNews({ pagesize: 50, pageIndex: 1 });
  },
  methods: {
    ...mapActions(['getNews'])
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/notification/news.vue